export default "__VITE_ASSET__Dv80VmVw__"